import React, { FC, useMemo } from "react";
import { defineMessages, useIntl } from "react-intl";
import Svg from "@natera/material/lib/svg";
import ArrowDownGrayIcon from "@assets/svg/icons/arrowDownGray.svg";
import InfoIcon from "@assets/svg/icons/info.svg";

import "./otpHelpAccordion.scss";

const messages = defineMessages({
  otpHelpAccordionTitle: {
    id: "otpHelpAccordionTitle",
    defaultMessage: "Still not seeing the code?",
  },
  otpHelpAccordionContent: {
    id: "otpHelpAccordionContent",
    defaultMessage:
      "Please check whether your email address is spelled correctly. Codes are sent only to registered email accounts. If you are unsure whether your account is registered, look for a sign up confirmation email in your inbox.",
  },
});

interface OtpHelpAccordionProps {
  expiryMinutes?: number;
  contentOverride?: string;
}

const OtpHelpAccordion: FC<OtpHelpAccordionProps> = ({
  expiryMinutes,
  contentOverride,
}) => {
  const intl = useIntl();

  const content = useMemo(
    () =>
      contentOverride ?? intl.formatMessage(messages.otpHelpAccordionContent),
    [intl, contentOverride]
  );

  return (
    <details className="otp-help-accordion">
      <summary className="otp-help-accordion__summary">
        <Svg content={InfoIcon} className="otp-help-accordion__icon" />
        <span className="otp-help-accordion__title">
          {intl.formatMessage(messages.otpHelpAccordionTitle)}
        </span>
        <Svg
          content={ArrowDownGrayIcon}
          className="otp-help-accordion__arrow"
        />
      </summary>
      <div className="otp-help-accordion__content">
        <p>{content}</p>
      </div>
    </details>
  );
};

export default OtpHelpAccordion;
